import { geniFetch } from "./geniBackend";

export type GenerationSessionKind = "image_edit" | "card_full" | "card_photo_only";

export type GeniLedgerDirection = "credit" | "debit";

export type GeniLedgerSubject =
  | "single_photo"
  | "product_card"
  | "purchase"
  | "admin"
  | "other";

export type GeniLedgerRow = {
  id: string;
  createdAt: string;
  direction: GeniLedgerDirection;
  amount: number;
  balanceAfter: number;
  subject: GeniLedgerSubject;
  reason: string;
  metadata: unknown;
};

export type BillingOverviewResponse = {
  generationTotals: {
    photosGenerated: number;
    textsGenerated: number;
    cardsCompleted: number;
  };
  ledger: GeniLedgerRow[];
};

export async function recordGenerationStat(payload: {
  sessionKind: GenerationSessionKind;
  imagesGenerated: number;
  textsGenerated: number;
}): Promise<void> {
  await geniFetch<{ ok: true }>("/account/generation-stat", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function getBillingOverview(): Promise<BillingOverviewResponse> {
  return geniFetch<BillingOverviewResponse>("/account/billing-overview", {
    method: "GET",
  });
}
